import { Building, ConstructableBuilding } from "../../../types/building";
import { MODE } from "../../../types/game";
import { Coord, Grid } from "../../../types/grid";
import { Unit } from "../../../types/unit";
import "./Map.css";
import { getBuildingAtThisCell, getUnitAtThisCell } from "./utils/cellInfo";

export default function Map({
  grid,
  units = [],
  buildings = [],
  onClick,
  onRightClick,
  onUnitClick,
  activeCell,
  mode,
  constructingBuilding,
  onBuildingConstructClick,
  onBuildingConstructCancel,
}: {
  grid: Grid;
  units?: Unit[];
  buildings?: Building[];
  onClick: (x: number, y: number) => void;
  onRightClick: (x: number, y: number) => void;
  onUnitClick?: (unit?: Unit) => void;
  activeCell?: Coord;
  mode: MODE;
  constructingBuilding?: ConstructableBuilding;
  onBuildingConstructClick?: (
    building: ConstructableBuilding,
    x: number,
    y: number
  ) => void;
  onBuildingConstructCancel?: () => void;
}) {
  return (
    <div>
      <div className="grid-wrapper">
        <div className="grid">
          {grid.map((row, idxY) => (
            <div key={idxY} className="row">
              {row.map((cell, idxX) => {
                let unit = getUnitAtThisCell({ units, x: idxX, y: idxY });
                let building = getBuildingAtThisCell({
                  buildings,
                  x: idxX,
                  y: idxY,
                });

                return (
                  <div key={idxX} className={`cell `}>
                    <div
                      key={idxX + "upper"}
                      className={`cell-inner upper ${
                        activeCell?.x === idxX &&
                        activeCell.y === idxY &&
                        "active"
                      }`}
                      onClick={() => {
                        onClick(idxY, idxX);
                      }}
                      onContextMenu={(e) => {
                        e.preventDefault();
                        onRightClick(idxY, idxX);
                      }}
                    ></div>
                    {unit && (
                      <div
                        className="character-wrapper"
                        onClick={() => {
                          onUnitClick && onUnitClick(unit);
                        }}
                      >
                        <img
                          src={`${process.env.PUBLIC_URL}/characters/hero.png`}
                          className="character-cell"
                          alt="hero"
                        />
                      </div>
                    )}
                    {building && (
                      <div
                        className="building-wrapper"
                        onClick={() => {
                          // onUnitClick && onUnitClick(unit);
                        }}
                      >
                        <img
                          src={`${process.env.PUBLIC_URL}/buildings/${building.src}`}
                          className="building-cell"
                          alt="building"
                        />
                      </div>
                    )}
                    {!building && constructingBuilding && (
                      <div
                        className="building-wrapper"
                        onClick={() => {
                          onBuildingConstructClick &&
                            onBuildingConstructClick(
                              constructingBuilding,
                              idxX,
                              idxY
                            );
                        }}
                        onContextMenu={(e) => {
                          e.preventDefault();
                          onBuildingConstructCancel &&
                            onBuildingConstructCancel();
                        }}
                      >
                        <img
                          src={`${process.env.PUBLIC_URL}/buildings/${constructingBuilding.src}`}
                          className="building-cell blueprint"
                          alt="building"
                        />
                      </div>
                    )}
                    <div
                      key={idxX + "lower"}
                      className={`cell-inner ${mode}`}
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/textures/${cell.src})`,
                      }}
                    ></div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
